import { LessonTask, LessonStep } from '../../../types/asset/lesson.types.ts';
import { ScriptProcessingResult, SpeakableScriptPartType } from '../../../types/asset/script.types.ts';

import { getLessonsUtil } from '../lessons.util.ts';

import { BaseScriptsProcessor } from './base-scripts-processor.ts';

/**
 * This processor is used to process the parts part of a script: "\\(parts[0].file)"
 */
export class ScriptsFilePartsProcessor extends BaseScriptsProcessor {
  public process(part: string, task: LessonTask, step: LessonStep): ScriptProcessingResult {
    if (part.startsWith('\\(') && part.endsWith('.file)')) {
      const partKey = part.slice(2, -6);
      if (partKey.startsWith('parts[')) {
        const partIndex = parseInt(partKey.slice(6, -1));
        const parts = getLessonsUtil().getStepParts(task, step);
        const letter = parts?.[partIndex];

        if (letter) {
          return { parts: [{ letter, type: SpeakableScriptPartType.Letter }], processed: true };
        } else {
          // Fall back to step letter if no word parts are found
          const stepLetter = getLessonsUtil().getStepLetter(task, step);
          if (stepLetter && partIndex === 0) {
            return { parts: [{ letter: stepLetter, type: SpeakableScriptPartType.Letter }], processed: true };
          }

          this.handleError(new Error('No letter found'), task, step);
          return { parts: [], processed: true };
        }
      }
    }
    return { parts: [], processed: false };
  }
}
